// test1015
(1015 && 0);
